import { render, staticRenderFns } from "./ProjectRecports.vue?vue&type=template&id=c3594d76"
import script from "./ProjectRecports.vue?vue&type=script&lang=js"
export * from "./ProjectRecports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports